let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("HYkbB")).then(() => parcelRequire('gXCe1'));